import * as React from 'react';

export function Grid({
  children,
  cols = 2,
}: {
  children: React.ReactNode;
  cols?: number;
}) {
  return (
    <div className={`flex flex-col gap-12 md:grid md:grid-cols-${cols}`}>
      {children}
    </div>
  );
}

export function Column({ children }: { children: React.ReactNode }) {
  return <div className="flex flex-col gap-6">{children}</div>;
}
